module.exports = __webpack_public_path__ + "static/img/v-hk21.3c76210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v-hk21.png
// module id = BRcy
// module chunks = 0